import React from 'react';
import { User, Devices } from '../../api/models';

type SetString = (x: string) => void;

export enum AuthPath {
  Dashboard = 'dashboard',
  Login = 'login',
  Logout = 'logout',
  Confirm = 'confirm',
}

export enum AuthSearch {
  ReturnTo = 'returnTo',
}

// undefined while loading, User if logged in, null if not.
export type MaybeUser = undefined | User | null;

export type MDNProp = { mdn: string };
export type PasswordProp = { password: string };
export type SetMDNProp = { setMdn: SetString };
export type SetPasswordProp = { setPassword: SetString };

export type PageContentProps = {
  heading: React.ReactNode;
  content?: React.ReactNode;
  errorMsg?: string;
  isLoading?: boolean;
};

export type AuthPageProps = MDNProp & SetMDNProp;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/auth/models.ts